<ion-item lines="none">
  <ion-label position="stacked">{{ label() }}</ion-label>
  <ion-input
    [type]="inputType"
    [formControl]="control()"
    [inputmode]="inputmode()"
    [autocomplete]="autocomplete()"
    [placeholder]="placeholder()"
    [class.ion-invalid]="control().touched && control().invalid"
    [class.ion-touched]="control().touched"
  >
    @if (showPasswordToggle()) {
      <ion-button
        slot="end"
        fill="clear"
        (click)="togglePasswordVisibility()"
        [attr.aria-label]="passwordVisibleState ? 'Hide password' : 'Show password'"
      >
        <ion-icon [name]="passwordVisibleState ? 'eye-off' : 'eye'"></ion-icon>
      </ion-button>
    }
  </ion-input>
</ion-item>
@if (getErrorMessage()) {
  <div class="field-error">
    <span>{{ getErrorMessage() }}</span>
  </div>
}
